import { createFileRoute } from '@tanstack/react-router';
import ExperiencesEntityCard from '../components/ExperiencesEntityCard';
import UnitsEntityCard from '../components/UnitsEntityCard';
import LocationsEntityCard from '../components/LocationsEntityCard';
import ProgramGoalsEntityCard from '../components/ProgramGoalsEntityCard';
import { checkSecurityDomain } from '../utils/auth';

export const Route = createFileRoute('/crm')({
  component: RouteComponent,
  beforeLoad: checkSecurityDomain({ routeObject: 'crm' }),
});

function RouteComponent() {
  return (
    <div className="grid grid-cols-1 gap-4 py-8 lg:grid-cols-2 xl:grid-cols-3">
      <ExperiencesEntityCard />
      <UnitsEntityCard />
      <LocationsEntityCard />
      <ProgramGoalsEntityCard />
    </div>
  );
}
